import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import {  MyProfileModel } from 'src/shared/model/UserProfile';

import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { Subject } from 'rxjs';
import { DynamicModalService } from '../ui-components/dynamic-modals/dynamic-modal.service';
import {getErrorMessageText} from '../helper';

@Component({
    selector: 'app-update-address',
    templateUrl: './update-address.component.html',
    styleUrls: [],
    standalone: false
})
export class UpdateAddressComponent implements OnInit {
    userProfileEntity: MyProfileModel = new MyProfileModel();

    display = false;
    alertMessage: string;

    clientCode: string;

    logoImageUrl: string;

    showHeader = true;
    public subjectOnClose: Subject<any>;
    actionToPerform = '';
    @ViewChild('txtCurrAddrEffectiveFrom', { static: true }) txtCurrAddrEffectiveFrom;
    @ViewChild('txtCurrAddrEffectiveTo', { static: true }) txtCurrAddrEffectiveTo;

    @ViewChild('txtLegalAddrEffectiveFrom', { static: true }) txtLegalAddrEffectiveFrom;
    @ViewChild('txtLegalAddrEffectiveTo', { static: true }) txtLegalAddrEffectiveTo;

    constructor(
        public rest: RestService,
        private authService: AuthServiceCustom,
        private dynamicModalService: DynamicModalService,
        private ngxService: NgxUiLoaderService,
        private abstractDataProvider: AbstractDataProvider) { }

    ngOnInit() {
        this.clientCode = this.authService.clientCode;
        this.getUserRelatedData();
    }

    getUserRelatedData() {
        Object.assign(this.userProfileEntity, this.authService.currentUserProfileEntity); // Copying the object to different object.
        this.txtCurrAddrEffectiveFrom.Value = this.userProfileEntity.CurrAddressBegMonthDay;
        this.txtCurrAddrEffectiveTo.Value = this.userProfileEntity.CurrAddressEndMonthDay;
        this.txtLegalAddrEffectiveFrom.Value = this.userProfileEntity.LegalAddressBegMonthDay;
        this.txtLegalAddrEffectiveTo.Value = this.userProfileEntity.LegalAddressEndMonthDay;
    }

    submit() {

        this.userProfileEntity.CurrAddressBegMonthDay = this.txtCurrAddrEffectiveFrom.Value;
        this.userProfileEntity.CurrAddressEndMonthDay = this.txtCurrAddrEffectiveTo.Value;
        this.userProfileEntity.LegalAddressBegMonthDay = this.txtLegalAddrEffectiveFrom.Value;
        this.userProfileEntity.LegalAddressEndMonthDay = this.txtLegalAddrEffectiveTo.Value;

        this.actionToPerform = '';
        this.abstractDataProvider.postData(this.userProfileEntity, 'api/Accounts/UpdateAddressRequestChange').subscribe(
            (posts) => {
                this.display = true;
                this.alertMessage = posts.Data.AlertMsgs[0];
                // if (posts.Data.status == ExecutionStatus.Success)
                this.actionToPerform = 'closeDialog';
            },
            error => {
              this.display = true;
              this.alertMessage =  getErrorMessageText(error);
            }
        );
    }

    cancel() {
        if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
            this.subjectOnClose.next(null);
            this.dynamicModalService.subject.next(null);
        } else {
            this.authService.navigateToUrl('home');
        }
    }

    onConfirm() {
        this.display = false;
        if (this.actionToPerform === 'closeDialog') {
            this.cancel();
        }
    }
}
